import { WarningCircle } from "@phosphor-icons/react";

const TimingsInput = ({
    kitchen_timings,
    pool_timings,
    service_start_time,
    service_end_time,
    checkin_time,
    checkout_time,
    onChange,
    errors,
}) => {
    return (
        <div className="input-group border-b-[1.5px] py-3">
            <label className="block text-sm">Kitchen Timings</label>
            <input
                type="text"
                value={kitchen_timings}
                onChange={(e) => onChange("kitchen_timings", e.target.value)}
                placeholder="e.g. 7:00 AM - 11:00 PM"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-lg"
            />
            {errors.kitchen_timings && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.kitchen_timings}
                </span>
            )}
            <label className="block text-sm mt-4">Pool Timings</label>
            <input
                type="text"
                value={pool_timings}
                onChange={(e) => onChange("pool_timings", e.target.value)}
                placeholder="e.g. 6:00 AM - 8:00 PM"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-lg"
            />
            {errors.pool_timings && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.pool_timings}
                </span>
            )}
            <label className="block text-sm mt-4">Serving Hours</label>
            <p className="text-xs text-[#8C9199]">
                Guests can raise requests only between these hours. Leave both
                blank to accept requests around the clock.
            </p>
            <div className="flex gap-3 mt-1">
                <div className="w-[45%]">
                    <label className="block text-xs text-[#8C9199]">From</label>
                    <input
                        type="time"
                        value={service_start_time}
                        onChange={(e) =>
                            onChange("service_start_time", e.target.value)
                        }
                        className="mt-1 block w-full p-2 border-[1.5px] border-gray-300 rounded-lg"
                    />
                </div>
                <div className="w-[45%]">
                    <label className="block text-xs text-[#8C9199]">To</label>
                    <input
                        type="time"
                        value={service_end_time}
                        onChange={(e) =>
                            onChange("service_end_time", e.target.value)
                        }
                        className="mt-1 block w-full p-2 border-[1.5px] border-gray-300 rounded-lg"
                    />
                </div>
            </div>
            {errors.service_hours && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.service_hours}
                </span>
            )}
            <label className="block text-sm mt-4">Standard Stay Hours</label>
            <p className="text-xs text-[#8C9199]">
                New bookings default to these times. Leave blank to keep
                whatever time the booking or PMS supplies.
            </p>
            <div className="flex gap-3 mt-1">
                <div className="w-[45%]">
                    <label className="block text-xs text-[#8C9199]">
                        Check-in
                    </label>
                    <input
                        type="time"
                        value={checkin_time}
                        onChange={(e) =>
                            onChange("checkin_time", e.target.value)
                        }
                        className="mt-1 block w-full p-2 border-[1.5px] border-gray-300 rounded-lg"
                    />
                </div>
                <div className="w-[45%]">
                    <label className="block text-xs text-[#8C9199]">
                        Checkout
                    </label>
                    <input
                        type="time"
                        value={checkout_time}
                        onChange={(e) =>
                            onChange("checkout_time", e.target.value)
                        }
                        className="mt-1 block w-full p-2 border-[1.5px] border-gray-300 rounded-lg"
                    />
                </div>
            </div>
            {errors.stay_hours && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {errors.stay_hours}
                </span>
            )}
        </div>
    );
};

export default TimingsInput;
